<template>
    <div class="exhibitor-page page">
        <PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
            <v-skeleton-loader
                v-if="this.isLoading"
                v-bind="attrs"
                type="card"
			/>
            
            <div v-else-if="exhibitor">
                <ButtonBack />

                <div v-if="exhibitor.partner_logo" class="exhibitor-page__content">
                    <div class="exhibitor-page__logo-wrapper">
                        <img 
                            class="exhibitor-page__logo"
                            :src="exhibitor.partner_logo" 
                            alt="partner logo"
                        />
                    </div>
                </div>
                <div class="exhibitor-page__info" v-bind:style="{marginTop: exhibitor.partner_logo ? '8px' : '30px'}">
                    <div v-if="siteSectionVisible" class="exhibitor-page__section">
                        <p v-if="exhibitor.partner_name" class="mb-0 mt-6">
                            <span class="exhibitor-page__info-name-label">
                                Exhibitor Name
                            </span>
                            <span class="exhibitor-page__info-name ml-3">
                                {{ exhibitor.partner_name }}
                            </span>
                        </p>
                        <a 
                            v-if="exhibitor.partner_site_url" 
                            class="exhibitor-page__info-site"
                            :href="exhibitor.partner_site_url"
                            target="_blank"
                        >
                            <Icon 
                                type="link"
                                :size="14"
                                color="var(--accent-color)"
                                :pr="8"
                            />
                            <span class="exhibitor-page__info-site-value">
                                {{ exhibitor.partner_site_url }}
                            </span>
                        </a>
                        <p 
                            v-if="exhibitor.partner_location" 
                            class="exhibitor-page__info-location" 
                            v-bind:style="{marginTop: exhibitor.partner_site_url ? '12px' : '24px'}"
                        >
                            <Icon 
                                type="pin"
                                :size="14"
                                color="#9B9B9B"
                                :pr="8"
                            />
                            <span class=exhibitor-page__info-location-value>
                                {{ exhibitor.partner_location }}
                            </span>
                        </p>
    
                        <v-divider 
                            v-if="contactInfoVisible || descriptionVisible || mapVisible || giveawaysVisible || filesVisible" 
                            class="exhibitor-page__divider" 
                        />
                    </div>
                    
                    <div v-if="contactInfoVisible" class="exhibitor-page__section">
                        <h3 class="exhibitor-page__title">
                            Contact Info
                        </h3>

                        <p v-if="exhibitor.partner_contact_name" class="exhibitor-page__section-row">
                            <span class="exhibitor-page__section-row-title">
                                Name
                            </span>
                            <span class="exhibitor-page__section-row-value">
                                {{ exhibitor.partner_contact_name }}
                            </span>
                        </p>
                        <p v-if="exhibitor.partner_contact_title" class="exhibitor-page__section-row">
                            <span class="exhibitor-page__section-row-title">
                                Title
                            </span>
                            <span class="exhibitor-page__section-row-value">
                                {{ exhibitor.partner_contact_title }}
                            </span>
                        </p>
                        <p v-if="exhibitor.partner_contact_phone" class="exhibitor-page__section-row">
                            <span class="exhibitor-page__section-row-title">
                                Phone
                            </span>
                            <span class="exhibitor-page__section-row-value">
                                {{ exhibitor.partner_contact_phone }}
                            </span>
                        </p>
                        <p v-if="exhibitor.partner_contact_email" class="exhibitor-page__section-row">
                            <span class="exhibitor-page__section-row-title">
                                Email
                            </span>
                            <span class="exhibitor-page__section-row-value">
                                {{ exhibitor.partner_contact_email }}
                            </span>
                        </p>
                        <p v-if="locationInfo" class="exhibitor-page__section-row">
                            <span class="exhibitor-page__section-row-title">
                                Location
                            </span>
                            <span class="exhibitor-page__section-row-value">
                                {{ locationInfo }}
                            </span>
                        </p>
                        <v-divider v-if="descriptionVisible || mapVisible || giveawaysVisible || filesVisible" class="exhibitor-page__divider" />
                    </div>
                    <div v-if="descriptionVisible" class="exhibitor-page__section">
                        <h3 class="exhibitor-page__title">
                            Description
                        </h3>
                        <p class="exhibitor-page__description">
                            {{ exhibitor.partner_description }}
                        </p>
                        <v-divider v-if="mapVisible || giveawaysVisible || filesVisible" class="exhibitor-page__divider" />
                    </div>
                    <div v-if="filesVisible" class="exhibitor-page__section">
                        <h3 class="exhibitor-page__title">
                            Files
                        </h3>
                        <ExhibitorFile 
                            v-for="file in exhibitor.uploads.slice(0, 3)"
                            :key="file.upload_id"
                            :file="file"
                        />
                        <div class="exhibitor-page__section-btn-wrapper">
                            <v-btn class="exhibitor-page__section-btn elevation-0" @click="toFilesPage">
                                Show All
                            </v-btn>
                        </div>
                        <v-divider v-if="mapVisible || giveawaysVisible" class="exhibitor-page__divider" />
                    </div>
                    <div v-if="mapVisible" class="exhibitor-page__section">
                        <h3 class="exhibitor-page__title">
                            Event Location
                        </h3>
                        <img 
                            :src="exhibitor.partner_map" 
                            class="exhibitor-page__logo"
                            alt="partner map" 
                        />
                        <v-divider v-if="giveawaysVisible" class="exhibitor-page__divider" />
                    </div>
                    <div v-if="giveawaysVisible" class="exhibitor-page__section">
                        <h3 class="exhibitor-page__title">
                            Event Giveaway(s)
                        </h3>
                        <div 
                            v-for="giveaway in exhibitor.partnerGiveaways" 
                            :key="giveaway.giveaway_id"
                            class="exhibitor-page__giveaway"
                        >
                            <img 
                                class="exhibitor-page__giveaway-image"
                                :src="giveaway.giveaway_image"
                                alt="giveaway image"
                            />
                            <p class="exhibitor-page__giveaway-name">
                                {{ giveaway.giveaway_name }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
		</div>
    </div>
</template>
<script>
import ButtonBack from '@/components/ButtonBack'
import PageBlocked from '@/components/PageBlocked'
import ExhibitorFile from '@/components/Event/ExhibitorFile'
import Block from '@/mixins/Block.js'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        ButtonBack,
        PageBlocked,
        ExhibitorFile
    },
    mixins: [Block],
    data() {
        return {
            attrs: {
                elevation: 0,
                class: 'pt-7',
            },
            pageBlockedName: 'events'
        }
    },
    methods: {
        ...mapActions('event', ['getExhibitorById']),

        toFilesPage() {
            this.$router.push({
                name: 'exhibitor-files-by-id',
                params: {
                    id: +this.$route.params.id
                }
            })
        }
    },
    computed: {
        ...mapGetters('event', ['isLoading', 'exhibitor']),

        siteSectionVisible() {
            const {
                partner_site_url,
                partner_location,
                partner_name
            } = this.exhibitor
            return !!(partner_site_url || partner_location || partner_name)
        },
        contactInfoVisible() {
            const { 
                partner_contact_name, 
                partner_contact_title,
                partner_contact_phone,
                partner_contact_email,
                partner_contact_city,
                partner_contact_state
            } = this.exhibitor
            return !!(partner_contact_name
            || partner_contact_title
            || partner_contact_phone
            || partner_contact_email
            || partner_contact_city
            || partner_contact_state)
        },
        descriptionVisible() {
            return !!this.exhibitor.partner_description
        },
        filesVisible() {
            return !!this.exhibitor.uploads.length
        },
        mapVisible() {
            return !!this.exhibitor.partner_map
        },
        giveawaysVisible() {
            return !!this.exhibitor.partnerGiveaways.length
        },
        locationInfo() {
            if (this.exhibitor) {
                const city = this.exhibitor.partner_contact_city
                const state = this.exhibitor.partner_contact_state
                if (!!city || !!state) {
                    return `${city ? city : ''}${city && state ? ',' : ''} ${state ? state : ''}`
                }
            }
            return null
        }
    },
    created() {
        this.getExhibitorById(+this.$route.params.id)
    }
}
</script>
<style lang="scss">
.exhibitor-page {

    &__content {
        margin-top: 30px;
    }

    &__info {
        background-color: #fff;
        border-radius: 10px;
        font-family: Montserrat, sans-serif;
        padding: 20px 30px;

        &-site {
            color: var(--accent-color) !important;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            text-decoration: none;
            margin-top: 12px;

            &-value {
                font-size: 13px;
                font-weight: 500;
                line-height: 19.37px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-break: break-word;
            }
        }

        &-name {
            color: #697583;
            font-size: 14px;
            line-height: 17.07px;

            &-label {
                color: var(--accent-color);
                font-size: 14px;
                font-weight: 700;
                line-height: 17.07px;
            }
        }

        &-location {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            margin-bottom: 0 !important;

            &-value {
                color: #9B9B9B;
                font-size: 13px;
                font-weight: 500;
                line-height: 19.37px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-break: break-word;
            }

            &-icon {
                color: #9B9B9B !important;
            }
        }
    }

    &__logo {
        width: 100%;
        max-height: 338px;
        object-fit: contain;

        &-wrapper {
            background-color: #fff;
            border-radius: 10px;
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    &__title {
        color: #4A4A4A;
        font-size: 16px;
        font-weight: 700;
        line-height: 19.5px;
        margin-bottom: 16px;
    }

    &__section {
        &-row {
            display: flex;
            justify-content: flex-start;
            flex-wrap: nowrap;
            margin-bottom: 12px !important;

            @media (max-width: 480px) {
                flex-direction: column;
            }

            span {
                font-size: 14px;
                line-height: 17.07px;
            }

            &-title {
                color: var(--accent-color);
                font-weight: 700;
                margin-right: 12px;
            }

            &-value {
                color: #697583;
            }
        }

        &-btn {
            background-color: transparent !important;
            color: var(--button-secondary-background-color) !important;
            text-transform: capitalize;
            text-decoration: underline;
            font-size: 14px;
            font-weight: 700;
            line-height: 17.07px;

            &-wrapper {
                display: flex;
                justify-content: center;
            }
        }
    }

    &__giveaway {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;

        &-image {
            width: 100px;
            height: 100px;
            border-radius: 8px;
            object-fit: cover;
            margin-right: 16px;
        }

        &-name {
            font-size: 15px;
            font-weight: 500;
            color: var(--accent-color);
            line-height: 20px;
            margin-bottom: 0 !important;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-word;
        }
    }

    &__description {
        font-size: 14px;
        line-height: 17.07px;
        color: var(--accent-color);
        margin-bottom: 0 !important;
    }

    &__divider {
        border-color: #E2E2E2 !important;
        margin: 24px 0;
    }
}
</style>